<div class="confirmation-dialog-container">
  <div class="dialog">
    <div class="text-container">
      <capra-icon icon="icon-info-outline"></capra-icon>
      <p class="dialog-text">This field has unapplied color changes. Do you want to apply the updates before switching?</p>
    </div>

    <div class="cta-container">
      <capra-button
        class="discard-cta"
        text="Discard"
        variant="secondary"
        color="neutral"
        size="small"
        data-test="discard-changes-cta"
        (clicked)="onClick(currentField, true)"
      ></capra-button>
      <capra-button
        class="apply-cta"
        text="Apply"
        variant="secondary"
        color="neutral"
        size="small"
        data-test="apply-changes-cta"
        (clicked)="onClick(currentField, false)"
      ></capra-button>
    </div>
  </div>
</div>